import {genericMandarkRequest} from 'resources/mandark.resource';
import {mandarkEndpoint} from '@albert-io/json-api-framework/request/builder/legacy';
import {resource} from '@albert-io/json-api-framework/request/builder';
import sessionStore from 'client/Session/SessionStore';

export const getDraftGuess = (questionId, assignmentId) => {
  const studentId = sessionStore.getUserId();

  const query = resource('draft_guesses_v1')
    .mandarkEndpoint(['students_v2', studentId, 'draft_guesses_v1'])
    .filter({
      student_v2: studentId,
      assignment_v3: assignmentId,
      question_v3: questionId
    })
    .done();

  return genericMandarkRequest('get', query);
};

export const patchDraftGuess = (draftId, payload) => {
  const query = mandarkEndpoint(['draft_guesses_v1', draftId]).done();
  const {content, timeElapsed} = payload;
  return genericMandarkRequest('patch', query, {
    data: {
      id: draftId,
      type: 'draft_guess_v1',
      attributes: {
        content,
        time_elapsed: timeElapsed
      }
    }
  });
};

export const saveDraftGuess = (payload, questionId, assignmentId) => {
  const query = mandarkEndpoint(['draft_guesses_v1']).done();
  const {content, timeElapsed} = payload;
  return genericMandarkRequest('post', query, {
    data: {
      attributes: {
        content,
        time_elapsed: timeElapsed
      },
      relationships: {
        assignment_v3: {
          data: {
            id: assignmentId,
            type: 'assignment_v3'
          }
        },
        student_v2: {
          data: {
            id: sessionStore.getUserId(),
            type: 'student_v2'
          }
        },
        question_v3: {
          data: {
            id: questionId,
            type: 'question_v3'
          }
        }
      }
    }
  });
};
